import React from "react";
import { Box, Typography } from "@mui/material";

export default function FieldRow({
  label,
  value,
  isEditing,
  children,
  emptyText = "-",
  multiline = false,
}) {
  const displayValue =
    value === null || value === undefined || value === "" ? emptyText : value;

  return (
    <Box className="entrevista-field-row">
      <Typography className="entrevista-field-row__label">{label}</Typography>
      {isEditing ? (
        children
      ) : (
        <Box className={`entrevista-field-row__value ${multiline ? "is-multiline" : ""}`}>
          <Typography>{displayValue}</Typography>
        </Box>
      )}
    </Box>
  );
}